export default __webpack_public_path__ + "static/media/pvn-site.f9abd6c7.webp";